<template>
    <div class="upload-picture">
        <upload-button
            ref="uploadButton"
            v-model="innerValue"
            :accept="accept"
            :disabled="buttonDisabled"
            :folder="folder"
            :hidden="hidden"
            :max="max"
            :max-size="maxSize"
            :multiple="multiple"
            :tip="tip"
            :title="title"
            @change="handleChange" />
        <div v-if="innerValue.length" class="picture-list">
            <div
                v-for="(item, index) in innerValue"
                :key="`${item.url || item.name || 'image'}-${index}`"
                class="picture-item"
                :style="itemStyle">
                <img
                    class="picture-image"
                    :src="item.url"
                    :style="imageStyle"
                    alt=""
                    @click="openPreview(index)" />
                <i v-if="!disabled" class="el-icon-close picture-remove" @click="removeItem(index)"></i>
            </div>
        </div>
        <image-viewer
            v-if="showImagePreview"
            :initial-index="previewIndex"
            :on-close="closePreview"
            :url-list="previewList" />
    </div>
</template>

<script>
import ImageViewer from "./image-viewer";

export default {
    name: 'UploadPicture',
    components: {
        ImageViewer
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        accept: {
            type: String,
            default: 'image/*'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        folder: {
            type: String,
            default: ''
        },
        hidden: {
            type: Boolean,
            default: false
        },
        height: {
            type: [Number, String],
            default: 180
        },
        max: {
            type: Number,
            default: 1
        },
        maxSize: {
            type: Number,
            default: 10
        },
        multiple: {
            type: Boolean,
            default: false
        },
        tip: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '上传图片'
        },
        width: {
            type: [Number, String],
            default: 180
        }
    },
    data() {
        return {
            innerValue: this.normalizeFileList(this.value),
            previewIndex: 0,
            showImagePreview: false
        }
    },
    computed: {
        previewList() {
            return this.innerValue.map(item => item.url).filter(Boolean)
        },
        buttonDisabled() {
            return this.disabled || this.innerValue.length >= this.max
        },
        itemStyle() {
            return {
                width: `${Number(this.width)}px`,
                height: `${Number(this.height)}px`
            }
        },
        imageStyle() {
            return {
                width: `${Number(this.width)}px`,
                height: `${Number(this.height)}px`
            }
        }
    },
    watch: {
        value(val) {
            this.innerValue = this.normalizeFileList(val)
        }
    },
    methods: {
        normalizeFileList(list) {
            if (!Array.isArray(list)) {
                return []
            }
            return list.map(item => {
                if (typeof item === 'string') {
                    return {
                        url: item,
                        name: item.split('/').pop()
                    }
                }
                return { ...item }
            })
        },
        openPicker() {
            if (this.$refs.uploadButton) {
                this.$refs.uploadButton.openPicker()
            }
        },
        handleChange(fileList) {
            this.innerValue = this.normalizeFileList(fileList)
            this.$emit('input', this.innerValue)
            this.$emit('change', this.innerValue)
        },
        openPreview(index) {
            if (!this.previewList.length) {
                return
            }
            this.previewIndex = index
            this.showImagePreview = true
        },
        closePreview() {
            this.showImagePreview = false
        },
        removeItem(index) {
            const fileList = this.innerValue.slice()
            fileList.splice(index, 1)
            this.handleChange(fileList)
        }
    }
}
</script>

<style scoped>
.picture-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
}

.picture-item {
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    background: #f5f7fa;
}

.picture-image {
    display: block;
}

.picture-remove {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 2;
    display: none;
    padding: 4px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    cursor: pointer;
    font-size: 14px;
}

.picture-item:hover .picture-remove {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadPicture.vue